




import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class ImageList extends Vue {
  loading = true

  @Prop(Number) imageId!: number
  @Prop({ default: '' }) src!: string

  @Emit('created')
  onCreated() {
    return this.imageId
  }

  @Watch('src')
  onChangeSrc(src: string) {
    this.loading = !src
  }

  created() {
    this.loading = !this.src
    this.onCreated()
  }
}
